export const CONFIDENCE_BADGE_COLOR_MAP: Record<string, string> = {
  confiável: '#378EF0',
  'muito confiável': '#33AB84',
};

export const ELASTICITY_GAUGE_SEGMENTS = [
  { from: 0, to: 0.1 },
  { from: 0.1, to: 0.25 },
  { from: 0.25, to: 1.2 },
  { from: 1.2, to: 2 },
] as const;

export const CROSS_ELASTICITY_URL = process.env.REACT_APP_IND_CROSS_ELASTICITY_SETUP_URL;
export const CROSS_ELASTICITY_ENGINE_URL = process.env.REACT_APP_IND_CROSS_ELASTICITY_ENGINE_URL;

export const PAGE_BLOCKER = {
  title: 'Descubra a competitividade que potencializa o seu Market Share e Rentabilidade - produto a produto, canal a canal.',
  subtitle: 'Disponível em outros planos do InfoPanel.',
  modal: {
    title: 'Quanto de market share e rentabilidade você está deixando na mesa?',
    subtitle:
      'A Análise de Elasticidade ajuda você a identificar onde atuar primeiro, encontrar a competitividade ideal e garantir aderência da sua estratégia de pricing.',
  },
};
